import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { ICON_ACTIVE_COLORS } from './ItemInteraction.constants';
import { ActionName } from '../../../../../../components/RecaptchaProvider/RecaptchaProvider.constants';
import useStorage from '../../../../../../hooks/use-storage';
import { LIKE_ANNOTATION } from '../../../../../../modules/catalog/constants/annotations';
import { updateItemAnnotation, getAnnotationKey } from '../../../../../../modules/catalog/services/annotations';
import ReactionPanel from '../../../../../../modules/engagement/components/ReactionPanel';
import { MenuItemPropType } from '../../../../../../services/proptypes';
import { MenuContext } from '../../../../FoodMenu.context';
import './ItemInteraction.css';
var defaultProps = {};
export default function ItemInteraction(_ref) {
  var item = _ref.item;
  var _useContext = useContext(MenuContext),
    showMenuLikes = _useContext.showMenuLikes,
    business = _useContext.business;
  if (!showMenuLikes) {
    return null;
  }
  if (_isEmpty(business)) {
    return null;
  }
  var businessId = business.id,
    businessType = business.type;
  var _item$annotations = item.annotations,
    annotations = _item$annotations === void 0 ? {} : _item$annotations,
    menuItemId = item._id;
  var _annotations$likeCoun = annotations.likeCount,
    likeCount = _annotations$likeCoun === void 0 ? 0 : _annotations$likeCoun;
  var key = getAnnotationKey(businessId, businessType, menuItemId, LIKE_ANNOTATION);
  var _useStorage = useStorage(key, false),
    _useStorage2 = _slicedToArray(_useStorage, 3),
    liked = _useStorage2[0],
    setLiked = _useStorage2[1],
    storageLoaded = _useStorage2[2];
  if (!storageLoaded) {
    return null;
  }
  function handleIconClick(_x, _x2) {
    return _handleIconClick.apply(this, arguments);
  }
  function _handleIconClick() {
    _handleIconClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(active, recaptchaToken) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            updateItemAnnotation(businessId, businessType, menuItemId, active, recaptchaToken, LIKE_ANNOTATION);
            setLiked(active);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleIconClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "item-interaction"
  }, /*#__PURE__*/React.createElement(ReactionPanel, {
    activeId: liked ? 'heart' : null
  }, /*#__PURE__*/React.createElement(ReactionPanel.ReactionIcon, {
    iconId: "heart",
    activeColor: ICON_ACTIVE_COLORS.heart,
    iconName: liked ? 'heart' : 'heart outline',
    initialCount: likeCount || 0,
    onClick: handleIconClick,
    action: ActionName.ANNOTATE_MENU_ITEM
  })));
}
ItemInteraction.defaultProps = defaultProps;